module.exports = __webpack_public_path__ + "static/media/CMMI2021.53baf2c0.png";